import React, { useEffect, useState, useContext } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import LabeledInput from '../common/LabeledInput.jsx';
import requests from '../utils/requests.js';
import functions from '../utils/functions.js';
import { s } from '../Style.jsx';

const Settings = () => {
    const { auth } = useContext(PersonContext);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);

    const [settings, setSettings] = useState(null);
    useEffect(() => {
        requests.getSettings(auth).then(settings => {
            setSettings(settings);
            setLoading(false);
            setValues({
                deliveryFee: settings?.deliveryFee || 0,
                taxRate: settings?.taxRate || 0,
                comissionRate: settings?.comissionRate || 0,
                stripeFee: settings?.stripeFee || 0,
            });
        });
    }
        , []);

    const [values, setValues] = useState({
        deliveryFee: settings?.deliveryFee || 0,
        taxRate: settings?.taxRate || 0,
        comissionRate: settings?.comissionRate || 0,
        stripeFee: settings?.stripeFee || 0,
    });

    return <div style={s.mobileContainer}>

        {(saving || loading) && <p><i className="fas fa-spinner fa-spin"></i></p>}
        {!saving && !loading && <>
            <div style={s.box}>
                <div style={s.table}>
                    <div style={s.cell(0)}>
                        <label style={{ flex: 1 }}>Delivery Fee</label>
                        <LabeledInput prefix="$" placeholder="0.00" value={values.deliveryFee} onChange={e => setValues({ ...values, deliveryFee: e })} type="number" />
                    </div>
                    <div style={s.cell(0)}>
                        <label style={{ flex: 1 }}>Stripe Fee</label>
                        <LabeledInput prefix="$" placeholder="0.00" value={values.stripeFee} onChange={e => setValues({ ...values, stripeFee: e })} type="number" />
                    </div>
                    <div style={s.cell(1)}>
                        <label style={{ flex: 1 }}>Tax Rate</label>
                        <LabeledInput prefix="%" placeholder="0.00" value={values.taxRate} onChange={e => setValues({ ...values, taxRate: e })} type="number" />
                    </div>
                    <div style={s.cell(1)}>
                        <label style={{ flex: 1 }}>Commission Rate</label>
                        <LabeledInput prefix="%" placeholder="0.00" value={values.comissionRate} onChange={e => setValues({ ...values, comissionRate: e })} type="number" />
                    </div>
                </div>

                <button style={{ marginRight: 4 }} onClick={() => {
                    setValues({
                        deliveryFee: settings?.deliveryFee,
                        taxRate: settings?.taxRate,
                        comissionRate: settings?.comissionRate,
                        stripeFee: settings?.stripeFee,
                    });
                }
                }>Cancel</button>
                <button onClick={async () => {
                    setSaving(true);
                    await requests.updateSettings(auth, { ...values });
                    setSaving(false);
                }
                }>Save</button>
            </div>
        </>}

    </div>;
}
export default Settings;